import * as React from "react";
import styled from "@mui/material/styles/styled";
import { LevelValue } from "../../dataInputTypes";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

//region [[ Styles ]]

const LevelShapeItemView = styled("div")(({ theme }) => ({}));

const LevelTriangle = styled("div")(
  ({ level, selected }: { level: LevelValue; selected: boolean }) => ({
    width: "0",
    height: "0",
    borderLeft: "45px solid transparent",
    borderRight: "0px solid transparent",
    borderBottom:
      "7px solid " +
      (selected
        ? level === LevelValue.LOW || level === LevelValue.HIGH
          ? KahunColorMap.Red
          : KahunColorMap.Secondary
        : RosebudColorMap.green1),
  }),
);

const LevelRectangle = styled("div")(
  ({ level, selected }: { level: LevelValue; selected: boolean }) => ({
    height:
      level === LevelValue.LOW
        ? "11px"
        : level === LevelValue.NORMAL
        ? "19.25px"
        : "27.5px",
    width: "45px",
    backgroundColor: selected
      ? level === LevelValue.LOW || level === LevelValue.HIGH
        ? KahunColorMap.Red
        : KahunColorMap.Secondary
      : RosebudColorMap.green1,
    color: selected ? "white" : "gray",
    fontSize: "12px",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    textTransform: "capitalize",
    paddingTop: "2px",
    lineHeight: "13px",
  }),
);

const LevelItem = styled("div")({
  display: "flex",
  flexDirection: "column",
  marginRight: "3px",
  cursor: "pointer",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface LevelShapeItemProps {
  level: LevelValue;
  onClick: () => void;
  selected: boolean;
  showTitle: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const LevelShapeItem = ({ ...props }: LevelShapeItemProps) => {
  return (
    <LevelShapeItemView>
      <LevelItem onClick={props.onClick}>
        <LevelTriangle level={props.level} selected={props.selected} />
        <LevelRectangle level={props.level} selected={props.selected}>
          {props.showTitle ? props.level.toString() : ""}
        </LevelRectangle>
      </LevelItem>
    </LevelShapeItemView>
  );
};
